// keyFactories/ux/workflowKeyFactory.ts
import { WorkflowRunFilters } from "@features/ux/work-flow/types";
import { ActionType, EntityType, ModuleType } from "../../queryKeyFactory";

export const workflowKeyFactory = {
  // Basic workflow operations
  workflowTable: (
    filters?: any
  ): [ModuleType, EntityType, ActionType, any?] => [
    "ux",
    "uxWorkflow",
    "list",
    filters,
  ],

  // Single workflow
  workflowById: (
    workflowId?: number
  ): [ModuleType, EntityType, ActionType, number?] => [
    "ux",
    "uxWorkflow",
    "detail",
    workflowId,
  ],

  // Workflow by status
  workflowsDraft: (): [ModuleType, EntityType, ActionType] => [
    "ux",
    "uxWorkflow",
    "draft",
  ],

  workflowsActive: (): [ModuleType, EntityType, ActionType] => [
    "ux",
    "uxWorkflow",
    "active",
  ],

  workflowsAll: (): [ModuleType, EntityType, ActionType] => [
    "ux",
    "uxWorkflow",
    "all",
  ],

  // Workflow runs
  workflowRuns: (
    page?: number,
    limit?: number,
    search_data?: string,
    statusDisplay?: string,
    type?: string
  ) => [
    "ux",
    "workflow",
    "runs",
    page,
    limit,
    search_data,
    statusDisplay,
    type,
  ],

  workflowRunById: (runId: number) => [
    "ux",
    "uxWorkflow",
    "workflowRunById",
    runId,
  ],

  // Workflow performance and stats
  workflowPerformance: (): [ModuleType, EntityType, ActionType] => [
    "ux",
    "uxWorkflowPerformance",
    "list",
  ],

  workflowStats: (): [ModuleType, EntityType, ActionType] => [
    "ux",
    "uxWorkflowStats",
    "list",
  ],

  workflowStat: (): [ModuleType, EntityType, ActionType] => [
    "ux",
    "uxWorkflowStat",
    "list",
  ],

  // Workflow notifications
  workflowNotifications: (): [ModuleType, EntityType, ActionType] => [
    "ux",
    "uxWorkflowNotifications",
    "list",
  ],

  // Event types (used in workflow triggers)
  eventType: (): [ModuleType, EntityType, ActionType] => [
    "ux",
    "uxEventType",
    "list",
  ],

  getAllSegments: (): [ModuleType, EntityType, ActionType] => [
    "ux",
    "uxWorkflow",
    "getAllSegment",
  ],

  // Message templates (used in workflow actions)
  messageTemplates: (
    channelType?: string
  ): [ModuleType, EntityType, ActionType, string?] => [
    "ux",
    "uxMessageTemplate",
    "list",
    channelType,
  ],

  // Template filters (if needed for workflow template selection)
  templatesFilter: (
    filters?: any
  ): [ModuleType, EntityType, ActionType, any?] => [
    "ux",
    "uxTemplate",
    "filtered",
    filters,
  ],
  getAllRecipientList: (): [ModuleType, EntityType, ActionType] => [
    "ux",
    "uxWorkflow",
    "recipientList",
  ],
  getAllCommunicationTemplatesByChannel: (
    search_data?: string,
    channel?: string
  ) => ["ux", "workflow", "templates", search_data, channel],
  getWorkflowDetails: (id: any) => ["ux", "workflow", "workflowDetails", id],
  getAllWorkflow: (
    page: number,
    limit: number,
    search?: string,
    audienceType?: number,
    actionType?: number,
    status?: number
  ): [
    ModuleType,
    EntityType,
    ActionType,
    number,
    number,
    string,
    number,
    number,
    number
  ] => [
    "ux",
    "uxWorkflow",
    "workflowlist",
    page,
    limit,
    search,
    audienceType,
    actionType,
    status,
  ],
  getAllWorkflowExecutionDetails: (
    workflowId: string,
    page: number,
    limit: number,
    search?: string
  ): [ModuleType, EntityType, ActionType, string, number, number, string] => [
    "ux",
    "uxWorkflow",
    "allWorkflowExecutionDetails",
    workflowId,
    page,
    limit,
    search,
  ],

  getWorkflowsExecutionDetails: (
    executionId: string
  ): [ModuleType, EntityType, ActionType, string] => [
    "ux",
    "uxWorkflow",
    "workflowExecutionDetails",
    executionId,
  ],

  getWorkflowsExecutionChannelSummary: (
    executionId: string,
    channel: string
  ): [ModuleType, EntityType, ActionType, string, string] => [
    "ux",
    "uxWorkflow",
    "workflowExecutionEmailSummary",
    executionId,
    channel,
  ],

  getAllWorkflowExecutionAllChannelRecipients: (
    executionId: string,
    channel: string,
    page: number,
    limit: number,
    search?: string
  ): [ModuleType, EntityType, ActionType, string, string, number, number, string] => [
    "ux",
    "uxWorkflow",
    "allWorkflowExecutionAllChannelRecipients",
    executionId,
    channel,
    page,
    limit,
    search,
  ],

  getAllRunHistory: (
    page: number,
    limit: number,
    search?: string,
    executionDateFrom?: string,
    executionDateTo?: string,
    channel?: string,
    audienceType?: string,
    actionType?: string,
  ): [
    ModuleType,
    EntityType,
    ActionType,
    number,
    number,
    string,
    string,
    string,
    string,
    string,
    string,
  ] => [
    "ux",
    "uxWorkflow",
    "workflowRunHistoryList",
    page,
    limit,
    search,
    executionDateFrom,
    executionDateTo,
    channel,
    audienceType,
    actionType,
  ],
  getRunHistorySummary: (): [ModuleType, EntityType, ActionType] => [
    "ux",
    "uxWorkflow",
    "workflowRunHistorySummary",
  ],
} as const;
